import React, { useContext } from 'react';
import { connectPagination, connectStats } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

import { AttendeeModeContext, PageSizeContext } from '../../../context/searchContext';
import useEventAttendeePdf from '../../../hooks/useEventAttendeePdf';
import { BodySmall, LinkSmall } from '@styled';

const SearchAttendeeListLastPage = ({ currentRefinement, nbHits }) => {
    const attendeeModeContext = useContext(AttendeeModeContext);
    const { eventAttendeePdf } = useEventAttendeePdf(attendeeModeContext?.event);

    const [pageSize] = useContext(PageSizeContext);
    const paginationLimit = Number(process.env.ALGOLIA_PAGINATION_LIMIT);
    const totalCount = nbHits > paginationLimit ? paginationLimit : nbHits;
    const rangeEnd = currentRefinement * pageSize.hitsPerPage;

    if (!eventAttendeePdf || totalCount < paginationLimit || rangeEnd <= paginationLimit) {
        return null;
    }

    return (
        <div className="mt-1rem">
            <BodySmall>
                Your search returned more than 1,000 results. Please use the filters on the left to narrow your search.
                To see a full list of attendees (pdf),{' '}
                <LinkSmall href={eventAttendeePdf} target="_blank">
                    click here
                </LinkSmall>
                .
            </BodySmall>
        </div>
    );
};

SearchAttendeeListLastPage.propTypes = {
    currentRefinement: PropTypes.number.isRequired,
    nbHits: PropTypes.number.isRequired,
};

export default connectStats(connectPagination(SearchAttendeeListLastPage));
